import { stdObject } from "../../../data/types/stdObject";
import { toPrice } from "../../../utils/toPrice";

const getAgentLabel = (key: number, t: any) => {
  switch (key) {
    case 1:
      return t("p.helper");
    case 2:
      return t("p.technician");
    default:
      return t("p.seller");
  }
};

export const openInnerSelection = ({
  key,
  index,
  data,
  value,
  itemCode,
  t,
  setMsg,
  setWindowValues,
  setModalData,
  tableList = [],
}: stdObject) => {
  let search =
    key === "FEC2" && typeof data.value === "string"
      ? data.value.split(" ").join("T")
      : key === "PRE"
        ? toPrice(data.value)
        : data.value;
  let newData: stdObject = {
    table: null,
    placeholder: "",
    keysList: null,
    title: t(`d.${key}`),
    type: key === "FEC2" ? "datetime-local" : "text",
    style: {
      width:
        ["PSE", "PAG", "INT", "TAL", "FEC2"].includes(key) ||
        typeof key === "number"
          ? "auto"
          : 100,
    },
    innerStyle: {},
    step: 4,
  };
  if (index > -1) {
    newData.index = index;
  }
  let newValues: stdObject = { search, table: newData.table };
  if (key === "PRE") {
    newValues = { ...newValues, ART: itemCode, PRE: value };
    newData.type = "number";
    newData.style = { width: 100 };
    newData.innerStyle = { textAlign: "right" };
    newData.inputStyle = {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    };
  } else if (
    typeof key === "number" ||
    ["PSE", "PAG", "GAR", "INT", "TAL"].includes(key)
  ) {
    search = "";
    switch (key) {
      case "PSE":
        newData = {
          ...newData,
          table: [{ CODPSE: "", NOMPSE: t("p.none") }, ...tableList],
          placeholder: t("p.searchByName"),
          keysList: ["NOMPSE"],
          step: "PSE",
        };
        break;
      case "PAG":
        newData = {
          ...newData,
          table: tableList.filter((e: stdObject) => e.ACTPAG === 1),
          placeholder: t("p.searchByName"),
          keysList: ["NOMPAG"],
          step: "PAG",
        };
        break;
      case "GAR":
        newData = {
          ...newData,
          table: [...tableList],
          placeholder: t("p.searchByNameOrCode"),
          keysList: ["CODART", "NOMART"],
          step: 5,
          guarantee: true,
        };
        break;
      case "INT":
        newData = {
          ...newData,
          table: [...tableList],
          placeholder: t("p.searchByNameOrCode"),
          keysList: ["CODART", "NOMART"],
          step: 5,
        };
        break;
      default:
        newData = {
          ...newData,
          table: [{ CODUSU: "", NOMUSU: t("p.none") }, ...tableList],
          placeholder: t("p.searchByName"),
          keysList: ["NOMUSU"],
          title: getAgentLabel(key, t),
        };
        break;
    }
    newValues = { search, table: newData.table };
  }
  setMsg("docInput");
  setWindowValues({ ...newValues });
  setModalData({
    field: data.field,
    codeKey: data.key,
    ...newData,
  });
};
